export type ArticleSummary = {
  slug: string;
  title: string;
  summary: string;
  category: string;
  tags: string[];
  readTime: string;
  publishedAt: string;
};

export const articles: ArticleSummary[] = [
  {
    slug: "pourquoi-creer-site-vitrine-2026",
    title: "Pourquoi créer un site vitrine en 2026 ? Crédibilité, contacts et visibilité locale",
    summary:
      "Un site vitrine utile pour convertir : preuve sociale, prise de contact, référencement naturel et crédibilité auprès des clients à Paris, en Île-de-France et partout en France.",
    category: "Site vitrine",
    tags: ["Création site vitrine", "Agence web Paris", "Référencement naturel"],
    readTime: "9 min",
    publishedAt: "2026-02-04",
  },
  {
    slug: "combien-coute-site-internet-paris-2026",
    title: "Combien coûte un site internet à Paris en 2026 ?",
    summary:
      "Prix d'un site vitrine, e-commerce ou sur mesure à Paris : découvrez les vrais postes de coût et comment éviter les mauvaises surprises.",
    category: "Budget",
    tags: ["Création de site internet à Paris", "Devis", "Agence web"],
    readTime: "10 min",
    publishedAt: "2026-02-10",
  },
  {
    slug: "comment-choisir-agence-web-paris",
    title: "Comment choisir une agence web à Paris ?",
    summary:
      "Les critères essentiels pour choisir une agence web à Paris : budget, délais, SEO, accompagnement, maintenance et qualité du suivi.",
    category: "Guide agence",
    tags: ["Agence web Paris", "Agence digitale", "Développement web"],
    readTime: "11 min",
    publishedAt: "2026-02-12",
  },
  {
    slug: "checklist-agence-web",
    title: "Comment choisir son agence web : checklist avant signature (Paris & France)",
    summary:
      "Les questions à poser pour éviter les devis flous : délais, refonte de site internet, SEO, maintenance et propriété des accès.",
    category: "Guide agence",
    tags: ["Agence web", "Checklist", "Création de site internet"],
    readTime: "10 min",
    publishedAt: "2026-01-28",
  },
  {
    slug: "creation-site-internet-paris-etapes",
    title: "Création de site internet à Paris : les étapes pour bien démarrer",
    summary:
      "De la définition de vos objectifs au lancement : cadrage, design, développement web, contenus et référencement naturel, sans jargon inutile.",
    category: "Méthode",
    tags: ["Création de site internet à Paris", "Site vitrine", "Agence digitale"],
    readTime: "9 min",
    publishedAt: "2026-02-14",
  },
  {
    slug: "reussir-refonte-sans-stress",
    title: "Réussir sa refonte de site internet : SEO, trafic et sérénité",
    summary:
      "Conserver votre trafic, sécuriser vos URLs et rassurer vos équipes : plan de refonte web avec priorités claires pour la France et les projets pilotés depuis Paris.",
    category: "Refonte",
    tags: ["Refonte de site internet", "Référencement naturel", "SEO"],
    readTime: "10 min",
    publishedAt: "2026-01-20",
  },
  {
    slug: "refonte-site-internet-quand-combien-coute",
    title: "Refonte de site internet : quand la faire et combien ça coûte ?",
    summary:
      "Design dépassé, site lent, faible conversion, SEO en baisse : découvrez quand lancer une refonte de site internet et comment cadrer le budget.",
    category: "Refonte",
    tags: ["Refonte de site internet", "Agence web Paris", "Budget"],
    readTime: "11 min",
    publishedAt: "2026-02-16",
  },
  {
    slug: "seo-intelligent-concurrents",
    title: "Référencement naturel : 5 leviers concrets pour gagner en visibilité (Paris & France)",
    summary:
      "Actions hebdo réalistes pour une PME : intention de recherche locale, pages services, vitesse, contenu utile et crédibilité — sans spam SEO.",
    category: "SEO",
    tags: ["Référencement naturel", "Agence web Paris", "Visibilité Google"],
    readTime: "9 min",
    publishedAt: "2026-01-15",
  },
  {
    slug: "automatiser-processus-metier",
    title: "Automatiser vos processus métier : gagner du temps et limiter les erreurs (PME)",
    summary:
      "Cas fréquents en PME, outils accessibles, pièges à éviter et comment une agence digitale peut connecter site, CRM et facturation proprement.",
    category: "Automatisation",
    tags: ["Automatisation", "Productivité", "Développement web"],
    readTime: "9 min",
    publishedAt: "2026-02-01",
  },
  {
    slug: "creer-site-ecommerce-reussi",
    title: "Site e-commerce : 7 étapes pour vendre plus et éviter les erreurs coûteuses",
    summary:
      "Conversion, tunnel d'achat, logistique, acquisition : l'essentiel pour un site e-commerce rentable, qu'il soit sur Shopify, WooCommerce ou sur mesure.",
    category: "E-commerce",
    tags: ["Site e-commerce", "Conversion", "Création de site internet"],
    readTime: "11 min",
    publishedAt: "2026-02-08",
  },
  {
    slug: "wordpress-shopify-site-sur-mesure",
    title: "WordPress, Shopify ou site sur mesure : que choisir pour votre projet ?",
    summary:
      "Quand un CMS classique suffit, quand une boutique Shopify est pertinente, et quand un développement web sur mesure est le bon investissement.",
    category: "Stratégie",
    tags: ["WordPress", "Shopify", "Développement web"],
    readTime: "10 min",
    publishedAt: "2026-02-18",
  },
];
